import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoalSign = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "falling-star 1",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12.0488 14.4887L13.4567 17.3276C13.6485 17.7228 14.1605 18.1019 14.5925 18.1745L17.1443 18.602C18.776 18.8761 19.16 20.0699 17.9841 21.2473L16.0004 23.2475C15.6644 23.5863 15.4804 24.2395 15.5844 24.7073L16.1523 27.1833C16.6003 29.1432 15.5684 29.9013 13.8485 28.8771L11.4568 27.4495C11.0249 27.1913 10.313 27.1913 9.87301 27.4495L7.48128 28.8771C5.76947 29.9013 4.72959 29.1351 5.17753 27.1833L5.74547 24.7073C5.84947 24.2395 5.66548 23.5863 5.32952 23.2475L3.34573 21.2473C2.17787 20.0699 2.55383 18.8761 4.18564 18.602L6.73736 18.1745C7.16132 18.1019 7.67325 17.7228 7.86524 17.3276L9.27308 14.4887C10.041 12.9482 11.2889 12.9482 12.0488 14.4887Z",
			stroke: "var(--stroke-0, #9565FD)",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M29.3333 2.66667L18.6667 13.3333M21.3333 2.66667L14.6667 9.33333M26.6667 13.3333L22.6667 17.3333",
			stroke: "var(--stroke-0, #9565FD)",
			strokeWidth: 2,
			strokeLinecap: "round"
		})]
	})
});
export default SvgGoalSign;
